
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"28","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('rect',{attrs:{"x":"2","y":"2.384","width":"24","height":"24","rx":"4","fill":"#fff"}})])]),_c('rect',{attrs:{"y":".384","width":"28","height":"28","rx":"4"}}),_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.207 10.177a1 1 0 010 1.414l-7 7a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L12.5 16.47l6.293-6.293a1 1 0 011.414 0z","fill":"#fff"}})])]);
        };
      

        module.exports = {
          
          render: render,
        };
      